/**
 * Named constants for the tab / category identifiers, so the raw string literals (`'all'`, `'epic'`,
 * `'project'`, `'goal'`) aren't spread across the panel, hooks, and mappers. This is the single
 * source of truth for these values.
 *
 * `as const` preserves each value's exact literal type (e.g. `ENTITY_TYPE.EPIC` is `'epic'`, not the
 * wider union), so it can be assigned to the narrowed `category` field (`Exclude<…, 'all'>`).
 */
export const ENTITY_TYPE = {
	ALL: 'all',
	EPIC: 'epic',
	GOAL: 'goal',
	PROJECT: 'project',
} as const;
